module.exports = __webpack_public_path__ + "media/images/pages/services-4d3bd9fa0d0ac69ac13c8c10b86b5a95.jpg";